export default __webpack_public_path__ + "static/media/Product-Background.d9cbeafd.png";